import * as geometryEngine from '@arcgis/core/geometry/geometryEngine.js';
import { resolve, type Source, SourceSchema } from '@/agent/refs';
import { linearToEsri, type LinearUnit } from './shared/units';
import type { Tool } from './types';

type Input = { from: Source; to: Source; units?: LinearUnit };

export const computeDistance: Tool<Input> = {
  name: 'compute_distance',
  description:
    'Edge-to-edge distance between two Sources, in the requested unit (default meters). Polygon edges are respected — this is NOT centroid-to-centroid.',
  input_schema: {
    type: 'object',
    properties: {
      from: SourceSchema,
      to: SourceSchema,
      units: { enum: ['meters', 'kilometers', 'feet', 'miles'] },
    },
    required: ['from', 'to'],
    additionalProperties: false,
  },
  execute: async ({ from, to, units = 'meters' }) => {
    const [a, b] = await Promise.all([resolve(from), resolve(to)]);
    if (!a.geometry || !b.geometry) {
      throw new Error('compute_distance: both sources need geometry');
    }
    const dist = geometryEngine.distance(
      a.geometry as Parameters<typeof geometryEngine.distance>[0],
      b.geometry as Parameters<typeof geometryEngine.distance>[1],
      linearToEsri(units),
    );
    return { distance: dist, units };
  },
};
